<div class="content text-center">
  <h1 class="display-1">BitcoinSocialSync.com</h1>
  <h3 class="display-4">Trust the Bitcoin social layer to fast sync your full node!</h3>
  <div class="buttons">
    <a class="btn btn-lg btn-bitcoin-color text-white" routerLink="/browse">Get started</a>
    <!-- <a class="btn btn-lg btn-dark text-white" routerLink="/faq">Learn more</a> -->
  </div>
</div>
<app-faq></app-faq>